

































import Vue from 'vue';
import Component from 'vue-class-component';
import { Employee, employeeApis, LoginRequired } from '@/api';
import '../public/static/sailer.js';

declare const EMPLOYEE: Employee;

@Component({
  errorCaptured: function(err, vm, info) {
    if (err instanceof LoginRequired) {
      this.$store.commit('perms/update', []);
      this.$store.commit('employee/update', null);
      this.$router.push({ name: 'Login', query: { redirect: this.$route.fullPath } });
    } else {
      console.log('error captured', err, vm, info);
      this.$notify.error({ title: '错误', message: err.message, duration: 3000 });
    }
  },
  computed: {
    employee() {
      return this.$store.state.employee.employee;
    },

    isLoginPage() {
      return this.$route.path === '/login';
    }
  }
})
export default class AppMobile extends Vue {
  background_color = '#b92929';
  active = 'my-info';
  activeName = '员工系统';
  stickyOffset: string | number = 0;
  showWinPaddingTop = false;
  statusTop = 0;

  get defaultActive() {
    const parts = this.$route.path.split('/');
    if (parts.length >= 2) {
      return `/${parts[1]}`;
    } else {
      return '/';
    }
  }

  hasPerm(name: string) {
    return this.$store.getters['perms/has'](name);
  }

  created() {
    if (!EMPLOYEE && window.location.pathname != '/login' && window.location.pathname != '/login/passwd') {
      this.$router.push({ name: 'Login', query: { redirect: window.location.pathname + window.location.search } });
    }
    // 兼容drugstore_crm里面的内置游览器
    if (navigator.userAgent.toLocaleLowerCase().includes('drugstore_crm')) {
      this.stickyOffset = '44px';
    }
    this.adaptNativeApp();
  }

  navSelect(index: string) {
    if (index.startsWith('/') && this.$route.path != index) {
      this.$router.push(index);
    }
  }

  async logout() {
    await employeeApis.logout();
    location.reload();
  }

  onChange(index: string) {
    switch (index) {
      case 'sites':
        this.activeName = '站点管理';
        return;
      default:
        this.activeName = '员工系统';
        return;
    }
  }

  routeTo() {
    if (window.history.length > 1) {
      this.$router.go(-1);
    } else {
      this.$router.push({ name: 'my-submit' });
    }
  }

  adaptNativeApp() {
    // 适配需要员工系统登录的app使用
    window.Sailer &&
      window.Sailer.isNative &&
      window.Sailer.screenTop('', res => {
        if (res.returnCode === '0000') {
          const dpr = window.Sailer.isAndroid ? window.devicePixelRatio || 1 : 1;
          const top = Math.ceil(Number(res.data || 0)) / dpr;
          this.statusTop = top;
          this.showWinPaddingTop = true;
        }
      });
  }
}
